export const SHOW_MODAL = 'delete_custom_field_modal: show';
export const HIDE_MODAL = 'delete_custom_field_modal: hide';
